import { TextInput } from "react-admin";
import { compose } from "redux";
import {
  withDisableOnWheel,
  withValidateOnKeyPress,
} from "./NumberInputNoWheel";

export default compose(withDisableOnWheel, withValidateOnKeyPress)(TextInput);
